import React, {Fragment, useEffect, useState} from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,Image,Modal} from 'react-bootstrap';
import axios from 'axios';
import logo from '../../img/logo_uam.png';
import RecepisseU from '../../components/UpdateSuccess';
import AlerteMessage from '../../components/AlerteMessage';
import {InputF,InputRadio} from '../../components/Input';
import Alert, { Alert2, Alert3 } from '../../components/Alerte';
import Update from '../Update/index';
import { useNavigate,useLocation } from 'react-router-dom';
import { useRef } from 'react';
import './inscription.css'
const UpdateInscription = ({props}) => {
    const { search } = useLocation();
    const [ine,setIne] = useState(false)
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [open, setOpen] = useState (false)
    const [message, setMessage] = useState (false)
    const [errMsg, setErrMsg] = useState('');
    const userRef = useRef();
    const errRef = useRef();
    const [auth, isAuth] = useState(false)
    const [dataForm, setDataForm] = useState('');
    const [photo, setPhoto] = useState(false);
    const [infos, setInfos] = useState('');
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 ; //1Mo
    const [show, setShow] = useState(false);
    const [showdoc, setShowdoc] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "copie_carte_id" : true,
        "releve" : true,
        "diplome_bac" : true,
        "visite_medicale" : true,
        "photo" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "copie_carte_id" : false,
        "releve" : false,
        "diplome_bac" : false,
        "visite_medicale" : false,
        "photo" : false,
    });
    const match = search.match(/email=(.*)/);
    const email = match?.[1];
    useEffect (() => {

        // const match = search.match(/email=(.*)/);
        // const email = match?.[1];
        // console.log(email)
        if (!email) {
            console.log("pas encore de mail dans la requete ")
        } else {
            axios({
                url:`https://depot.uam.sn/api/v1/inscription/test/?email=${email}`,
                method: 'POST',
            })
            .then(result => {
                if (result?.data?.message) {
                    console.log("impossile de retrouver le candidat");
                    navigate("/");
                } else {
                     //console.log('donnes : ', result?.data);
                     isAuth(true)
                     setInfos(result.data.data)
                     
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
        }
        
       }, [email])
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        const elements = document.getElementsByName(key)
        // console.log(selectedFiles.publication7)
        let file = event.target.files[0];
        if (file?.size < maxFileSize){
            if (key === 'photo') {
                if (file.type ==='image/jpeg') {
                    var filesinfos = file.slice(0, file.size, 'image/jpeg'); 
                    file = new File([filesinfos], `${infos.codePermanent}.jpeg`, {type: 'image/jpeg'});
                    console.log(file)
                    setPhoto(false)
                    setSelectedFiles((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: file
                    }));
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: true
                    }));
                    for (var i = 0; i < elements.length; i++) {
                        var element1 = elements[i];
                        // console.log(element)
                        // Faites quelque chose avec chaque élément, par exemple :
                        element1.style.border = ""; // Applique une bordure rouge
                        // ... autres opérations sur l'élément
                    }
                } else {
                    setPhoto(true)
                    setOpen(true)
                    setMessage("format de fichier non permis")
                    console.log("format de fichier non permis ")
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: false
                    }));
                    return
                }
                
            }
            console.log(file)
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: file
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: true
            }));
            for (var i = 0; i < elements.length; i++) {
                var element1 = elements[i];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element1.style.border = ""; // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element.style.border = "2px solid #BC0C0C";
                element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }

        }
    };
    const navigate = useNavigate('')
    const handleCheckbox = (event) => {
        setDataForm({ ...dataForm, [event.target.name]: event.target.value });
        console.log(event.target.value)
        
    }
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    const handleSubmit = async (e) => {
        if (!auth) {
            axios({
                url:`https://depot.uam.sn/api/v1/inscription/ishere/?email=${user}&codePermanent=${pwd}`,
                method: 'POST',
            })
            .then(result => {
                if (result.data.detail) {
                    console.log(result.data.detail)
                        setOpen(true)
                        setMessage(result.data.detail)
                        setInfos(result.data.data)
                        console.log(infos)
                } else {
                        isAuth(true)
                        setMessage('Votre dossier n\'as pas été enregistré')
                        setInfos(result.data.data)
                        console.log(infos)
                        console.log(result.data.data)
                }
            })
            .catch((error) => {
                console.error('Error:', error)
                setOpen(true)
                setMessage('Erreur veuiller réessayer')
                
            });
        } else {
            try {
                e.preventDefault();
                const formData = new FormData();
                formData.append('email',infos.email)
                formData.append('date_naissance',infos.date_naissance)
                formData.append('prenom',infos.prenom)
                formData.append('nom',infos.nom)
                formData.append('codePermanent',infos.codePermanent)
                const nameFiles = ["copie_carte_id","releve","diplome_bac","visite_medicale","photo"]
                for (const i in nameFiles) {
                    if (selectedFiles[nameFiles[i]]) {
                        if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                            formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                        } else {
                            // console.log("fichier trop gros");
                        }
                    }
                }
                for (let key in dataForm) {
                    // console.log(dataForm[key])
                    if (dataForm.hasOwnProperty(key)) {
                          if( dataForm[key] !== null) {
                            if (key === 'pays') {
                                if (dataForm['type_poste'] === 'PATS') {
                                    if (dataForm['pays'] !== 'senegal') {
                                        dataForm['pays'] = 'SENEGAL'
                                    }
                                }
                            }
                            formData.append(key ,dataForm[key])
                          }
                  }
                }
                var showALerte = nameFiles.some(field => selectedFiles[field] === false);
             for (let pair of formData.entries()) {
                    console.log(pair[0] + ':' + pair[1]);
                }
                if (showALerte) {
                     setShow(true);
                    //  setOk(false)
                }
                else if (photo) {
                    setOpen(true)
                    setMessage('Format de la photo incorrect')
                }
                else {
                    setComplete(true)
                    setSubmitted(true);
                    // console.log("Requete en cours d'envoi ...")
                    const response = await axios.post(
                        'https://depot.uam.sn/api/v1/inscription/update/',
                        formData,
                {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                        });
                // console.log(response)
                if (response.status === 200) {
                    if (response.data.detail) {
                        setSubmitted(false);
                        // console.log(response.data.detail)
                        setDeppotSuccess2(true)
                    } else {
                        // console.log(response)
                        setSubmitted(false);
                        // console.log('Files uploaded successfully');
                        // console.log('Recepissé :' + response?.data?.data)
                        const dataPersonDepot = response?.data?.data;
                        setData(dataPersonDepot);
                        setDeppotSuccess(true);
                        // console.log("message : " + response.data.message);
                        // console.log(data);
                    }
                } else {
                    console.error('Error uploading files');
                    console.log("Détail de la réponse ",response.status)
                }
            }
        } catch (error) {
            setSubmitted(false);
           console.error('Error', error);
        }
    }
        
};
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
    const handleClose3 = () => {
        setOpen(false)
    }
    const handleClose4 = () => {
        setShowdoc(false)
    }
    const handleModifierClick = (e,key) => {
        console.log(e)
        console.log(key)
        const champInput = document.querySelector(`[name=${key}]`);
        champInput.click()
        console.log(champInput)
        // champInput.click()
      };
  return (
    <>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        {errors ? <Alert3 message = 'Vous devez faire la préinscription en ligne avant de compléter votre dossier' /> : null }
        <Alert show={show} handleClose={handleClose} />
        {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
        {depotsuccess ? <RecepisseU  dataPerson={data}/> : null}
        {update ? <Update /> : null}
        <div>
            <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
                {/* <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button>  */}
                {/* <Button variant='success' className=' p-1 '>Supprimer  son dossier </Button>*/}
            </div>
            {/* {aprés authentification} */}
            {auth ? 
            <>
             {ine
              ? navigate('/paiement') : 
              <div className='container mb-2 ' id='mainDepot'>
              <div id='nameModule' className=''>
                  <p> {'Informations Complémentaires' }</p>
              </div>
              <div id="form" className='inscription'>
                  <Form onSubmit={handleSubmit}>
                  <div id="step1" className='mb-3'>
                      {/* <Input type='email' readOnly={true} className='' required={false}  value={infos.email} label="Adresse mail" name='email'/> */}
                      <div className='row' id='test'>
                        <Form.Group className="col-md-6 col-sm-12" id="">
                            <Form.Label className='fw-medium'>Prénom(s)</Form.Label>
                            <Form.Control
                            className=""
                            size='md'
                            type='text'
                            name='prenom'
                            defaultValue={infos.prenom}
                            onChange={handleChange}
                            />
                         </Form.Group>
                        <Form.Group className="col-md-6 col-sm-12" id="">
                            <Form.Label className='fw-medium'>Nom</Form.Label>
                            <Form.Control
                            className=""
                            size='md'
                            type='text'
                            name='nom'
                            defaultValue={infos.nom}
                            onChange={handleChange}
                            />
                         </Form.Group>
                      </div>
                      <div className='row'>
                      <Form.Group className="" id="">
                        <Form.Label className='fw-medium'>INE</Form.Label>
                            <Form.Control
                            className=""
                            size='md'
                            type='text'
                            name='ine'
                            defaultValue={infos.ine}
                            onChange={handleChange}
                            />
                    </Form.Group>
                      <Form.Group className="" id="">
                        <Form.Label className='fw-medium'>Numero d'identificcation nationale</Form.Label>
                            <Form.Control
                            className=""
                            size='md'
                            type='text'
                            name='cni'
                            defaultValue={infos.cni}
                            onChange={handleChange}
                            />
                    </Form.Group>
                      </div> 
                    <Form.Group className='' id="">
                        <Form.Label className='fw-medium'>Téléphone</Form.Label>
                        <Form.Control
                            className=''
                            size='md'
                            required
                            defaultValue={infos.telephone}
                            type='number'
                            name='telephone'
                            placeholder='XXXXXXX'
                            onChange={handleChange}
                    />
                    </Form.Group>
                      <Form.Group id='niveau'>
                                <Form.Label className='fw-medium'>Situation matrimoniale <span style={{color:'red'}}>*</span> </Form.Label>
                                <InputRadio name='situation' value="Celibataire" label="Celibataire" onChange={(e) => handleCheckbox(e)}/>
                                <InputRadio name='situation' value="Marié" label="Marié(e)" onChange={(e) => handleCheckbox(e)}/>
                                {/* <InputRadio name='situation' value="Divorcé" label="Divorcé(e)" onChange={(e) => handleCheckbox(e)}/>
                                <InputRadio name='situation' value="Veuve" label="Veuve" onChange={(e) => handleCheckbox(e)}/> */}
                        </Form.Group>
                    <Form.Group className='' id="">
                        <Form.Label className='fw-medium'>Nombre d'enfants</Form.Label>
                        <Form.Control
                            className=''
                            size='md'
                            required
                            defaultValue={infos.enfant}
                            type='number'
                            name='telephone'
                            placeholder=''
                            onChange={handleChange}
                    />
                    </Form.Group>
                  </div>

                  <div id="files">
                    <button type='button' className="btn btn-success mb-2" onClick={() => setShowdoc(true)}>Consulter mes documents</button>
                    <Modal
                        show={showdoc}
                        onHide={handleClose4}
                        keyboard={false}
                    >
         <Modal.Header >
        <Modal.Title>Mes documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <table className="candidate-table">
        <tbody>
          <tr>
              <th>Copie carte d'identité nationale </th>
              <td>:</td>
              <td>
                <button className="btn btn-outline-primary uam-primary"
                    style={{color : "#993938", borderColor: "#993938"}}
                    onClick={() =>{
                        window.open(`https://depot.uam.sn/api/v1/inscription/view/${infos.copie_carte_id}`);
                    }} >
                    consulter
                </button>
                <button
                className="pl-2 btn btn-success uam-success ml-2"
                style={{ color: "#227849", borderColor: "#227849" }}
                onClick={(e) => handleModifierClick(e,"copie_carte_id")}
              >
                Modifier
              </button>
              </td>
          </tr>
          <tr>
              <th>Diplome BAC</th>
              <td>:</td>
              <td>
                <button className="btn btn-outline-primary uam-primary"
                    style={{color : "#993938", borderColor: "#993938"}}
                    onClick={() =>{
                        window.open(`https://depot.uam.sn/api/v1/inscription/view/${infos.diplome_bac}`);
                    }} >
                    consulter
                </button>
                <button
                className="pl-2 btn btn-success uam-success ml-2"
                style={{ color: "#227849", borderColor: "#227849" }}
                onClick={(e) => handleModifierClick(e,"diplome_bac")}
              >
                Modifier
              </button>
              </td>
          </tr>
          <tr>
              <th>Releve </th>
              <td>:</td>
              <td>
                <button className="btn btn-outline-primary uam-primary"
                    style={{color : "#993938", borderColor: "#993938"}}
                    onClick={() =>{
                        window.open(`https://depot.uam.sn/api/v1/inscription/view/${infos.releve}`);
                    }} >
                    consulter
                </button>
                <button
                className="pl-2 btn btn-success uam-success ml-2"
                style={{ color: "#227849", borderColor: "#227849" }}
                onClick={(e) => handleModifierClick(e,"releve")}
              >
                Modifier
              </button>
              </td>
          </tr>
          <tr>
              <th>Visiste medicale</th>
              <td>:</td>
              <td>
                <button className="btn btn-outline-primary uam-primary"
                    style={{color : "#993938", borderColor: "#993938"}}
                    onClick={() =>{
                        window.open(`https://depot.uam.sn/api/v1/inscription/view/${infos.visite_medicale}`);
                    }} >
                    consulter
                </button>
                <button
                className="pl-2 btn btn-success uam-success ml-2"
                style={{ color: "#227849", borderColor: "#227849" }}
                onClick={(e) => handleModifierClick(e,"visite_medicale")}
              >
                Modifier
              </button>
              </td>
          </tr>
          <tr>
              <th>Photo</th>
              <td>:</td>
              <td>
                <button className="btn btn-outline-primary uam-primary"
                    style={{color : "#993938", borderColor: "#993938"}}
                    onClick={() =>{
                        window.open(`https://depot.uam.sn/api/v1/inscription/view/${infos.photo}`, "popup");
                    }} >
                    consulter
                </button>
                <button
                className="ml-2 btn btn-success uam-success ml-2"
                style={{ color: "#227849", borderColor: "#227849" }}
                onClick={(e) => handleModifierClick(e,"photo")}
              >
                Modifier
              </button>
              </td>
          </tr>
          </tbody>
      </table>
      <div id="files">
            <InputF id=""  className="rounded-left mb-2 champModification" label="Copie légalisée de la Carte d'identité nationnale" type='file' message={<span style={{color:'red'}}>*</span>} name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
            {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null}
            <InputF   className="rounded-left mb-2" label="Relevé de BAC" message={<span style={{color:'red'}}>*</span>} type='file' name='releve' onChange={(e) => handleFileChange(e,"releve")} />
            {!selectedFiles["releve"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null} 
            <InputF   className="rounded-left mb-2" label="Diplome du BAC" message={<span style={{color:'red'}}>*</span>} type='file' name='diplome_bac' onChange={(e) => handleFileChange(e,"diplome_bac")} />
            {!selectedFiles["diplome_bac"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null} 
            <InputF   className="rounded-left mb-2" label="Certificat de visite et de contre visite " message={<span style={{color:'red'}}>*</span>} type='file' name='visite_medicale' onChange={(e) => handleFileChange(e,"visite_medicale")} />
            {!selectedFiles["visite_medicale"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null} 
            <InputF required={true} accept='.jpeg, .jpg'  className="rounded-left mb-2" label="Photo d'identité numérique de fond Blanc (fichier de type JPEG, claire, sans reflet, ni ombre). Photo utilisée pour la carte d'étudiant. Toutes photos ne respectant pas les indications seront rejetées" message={<span style={{color:'red'}}>*</span>} type='file' name='photo' onChange={(e) => handleFileChange(e,"photo")} />
            {!selectedFiles["photo"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . <br /></span> : null}
            {photo ? <span style={{color:'red'}}>Format du fichier Incorrect (type JPEG attendus )<br /></span> : null}
      </div>
      </Modal.Body>
      <Modal.Footer>
              <Button variant="outline-success" onClick={handleClose4}>
                {selectedFiles['photo'] || selectedFiles['copie_carte_id'] || selectedFiles["releve"] || selectedFiles["visite_medicale"] || selectedFiles["diplome_bac"] ? 'Valider les changements ' : 'Fermer'}
              </Button>
        </Modal.Footer>
      </Modal>
                
                  </div>
                  <div className="buttons">
                  <Button  variant="primary" type='submit' size="md"
                  className="p-2 float-end mb-3 mt-3">
                      Valider les modifications  {submitted ?
                          <Spinner animation="grow"
                          size="sm" role="status"
                          >
                          <span className="visually-hidden">Loading...</span>
                          </Spinner>
                          : null}
                  </Button>
                  </div>
                  </Form>
              </div>
          </div>
             }
           
            </>
           
            // { s'il n'est pas authentifié !}
            : <Form onSubmit={handleSubmit} style={{display:"inline-block"}}>
                <p ref={errRef} className={errMsg ? "errMsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                <div className="row container border border-primary depotdossier" id="test">
                    <div id="bodyForm">
                        <div>
                        <p><Image src={logo} width={90} height={100} /> <br /> <b>Dossier complémentaire</b></p>
                        </div>
                        <Form.Group className="col-12" controlId="formBasicEmail">
                            <Form.Label className=''><h5>Email personnel : </h5></Form.Label>
                            <Form.Control
                                    type="email"
                                    name="email"
                                    value = {user}
                                    onChange={(e) => setUser(e.target.value)}
                                    placeholder="Enter email"
                                    required
                                />
                        </Form.Group>
                        <Form.Group className="col-12" controlId="formBasicPassword">
                            <Form.Label className=''><h5>Code Permanent : </h5></Form.Label>
                                <Form.Control
                                        type="codepermanent"
                                        name="codepermanent"
                                        value={pwd}
                                        onChange={(e) => setPwd(e.target.value)}
                                        placeholder="123456"
                                        required  
                                    />
                        </Form.Group>
                    </div>
                    <div>
                        <Button
                            variant="success"
                            id="test"
                            className="btn-xl float-end"
                            style={{margin:'9px'}}
                            onClick={handleSubmit}
                            >
                            Envoyer {submitted ? <Spinner animation="grow" size="sm" role="status" /> : null}
                        </Button>
                    </div>
                </div>
            </Form>}
        </div>
    </>
  )
}
export default UpdateInscription